
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0A1551","d":"M5.976 19.007c.378.366.111.993-.425.993H2.195c-.662 0-1.2-.522-1.2-1.164v-3.253c0-.52.647-.778 1.024-.412z"}}),_c('path',{attrs:{"fill":"#FFB629","d":"M11.222 19.26a2.515 2.515 0 0 1 0-3.574l3.585-3.561a2.555 2.555 0 0 1 3.597 0 2.515 2.515 0 0 1 0 3.573l-3.585 3.562a2.555 2.555 0 0 1-3.597 0"}}),_c('path',{attrs:{"fill":"#09F","d":"M1.752 10.311a2.515 2.515 0 0 1 0-3.573L7.784.74a2.555 2.555 0 0 1 3.597 0 2.515 2.515 0 0 1 0 3.574L5.35 10.31a2.555 2.555 0 0 1-3.597 0"}}),_c('path',{attrs:{"fill":"#FF6100","d":"M6.683 14.586a2.515 2.515 0 0 1 0-3.574l8.152-8.098a2.555 2.555 0 0 1 3.597 0 2.515 2.515 0 0 1 0 3.574l-8.152 8.098a2.555 2.555 0 0 1-3.597 0"}})])
          )
        }
      }
    